var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-select',_vm._b({model:{value:(_setup.newValue),callback:function ($$v) {_setup.newValue=$$v},expression:"newValue"}},'v-select',_setup.currentProperties(),false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }